/**
 * Scope — where an asset belongs. Mirrors Python `flow_sdk/assets/placement.py` `Scope`
 * (re-exported as `flow_sdk/fs_store/scope.py`).
 */
export enum Scope {
  USER = 'user',
  PROJECT = 'project',
  SYSTEM = 'system',
}
